"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.primary = '#E20613';
exports.secondary = '#f8694f';
exports._default = '#1b1b1b';
exports.primaryContrast = '#f9f9f9';
exports.secondaryContrast = exports.primaryContrast;
exports.defaultContrast = exports.primaryContrast;
exports.primaryDark = '#7c0b04';
exports.secondaryDark = '#883a2c';
exports.defaultDark = exports.defaultContrast;
exports.primaryContrastDark = '#fffaf9';
exports.secondaryContrastDark = '#f7f0f0';
exports.defaultContrastDark = exports._default;